import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=36f1993e&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=36f1993e&prod&scoped=true&lang=css"
import style1 from "./SignaturePad.vue?vue&type=style&index=1&id=36f1993e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f1993e",
  null
  
)

export default component.exports